export const productCategories = `
  data {
  id
    attributes {
      spirit
      title
    }
  }
`;